import React, { FC, useState } from 'react';

import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getInitialPerson } from '../utils';
import { ages } from '../utils';

type PersonType = {
  id: number;
  name: string;
  age?: number;
  covers: boolean[];
};

type PersonsProps = {
  persons: PersonType[];
  onChange: (persons: PersonType[]) => void;
};
const Persons: FC<PersonsProps> = ({
  persons: propsPersons,
  onChange: handlePersonChange,
}) => {
  const [persons, setPersons] = useState<PersonType[]>(propsPersons);

  const handleChange = (newPerson: PersonType) => {
    const index = persons.findIndex((person) => person.id === newPerson.id);
    const newPersons = [
      ...persons.slice(0, index),
      { ...newPerson },
      ...persons.slice(index + 1),
    ];
    setPersons(newPersons);
    handlePersonChange(newPersons);
  };

  const handleRemoveClick = (id: number) => {
    const index = persons.findIndex((person) => person.id === id);
    const newPersons = [
      ...persons.slice(0, index),
      ...persons.slice(index + 1),
    ];

    setPersons(newPersons);
    handlePersonChange(newPersons);
  };

  const handleAddClick = () => {
    const newPersons = [...persons, getInitialPerson(persons.length + 1)];
    setPersons(newPersons);
    handlePersonChange(newPersons);
  };

  return (
    <div className="py-2">
      <div className="persons">
        {persons.map((person, index) => (
          <div key={person.id} className="person_item">
            <div className="remove_button" onClick={() => handleRemoveClick(person.id)}>
              <span>הסר</span>
              <FontAwesomeIcon
                className="cursor-pointer"
                icon={faMinus}
              />
            </div>
            <div className="field flex flex-col">
              <label>שם המבוטח/ת:</label>
              <input
                placeholder="שם מלא"
                //value={person.name}
                onChange={(e) =>
                  handleChange({
                    ...person,
                    name: e.target.value,
                  })
                }
              />
            </div>
            <div className="field flex flex-col">
              <label>גיל:</label>
              <div className="select">
                <select
                  value={person.age}
                  onChange={(e) =>
                    handleChange({ ...person, age: Number(e.target.value) })
                  }
                >
                  {ages.map((age) => (
                    <option key={age} value={age}>
                      {age}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/*}
            <div className="field flex flex-col">
              <label>סה״כ כיסויים שנבחרו:</label>
              <p>
                {person.covers.filter((cover) => cover).length}
              </p>
            </div>
            */}
          </div>
        ))}
        <div className="h-full flex items-center justify-center">
          <div className="add_button" onClick={handleAddClick}>
            <span>הוסף מבוטח/ת</span>
            <FontAwesomeIcon
              className="cursor-pointer"
              icon={faPlus}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Persons;
